module.exports = __webpack_public_path__ + "static/media/return-processing-fee-1.be32d299.png";